export const auth = {
  signInFailed: 'Sign-in failed',
  checkingSession: 'Checking your session…',
  redirectingToSignIn: 'Redirecting to sign-in…',
  signingIn: 'Signing you in…',
  backToDashboard: 'Back to the dashboard',
} as const;
